import { data } from '../../svg/AICompose/data';
import { makeIcon } from '../makeIcon';

export const AICompose = makeIcon(data, 'ai_compose', 'AICompose');

export default AICompose;
